export function formatNumber(n: number): string {
    return new Intl.NumberFormat("fr-FR").format(n);
}

/** Whole-euro TTC price for vehicle card vignettes (no cents). */
export function formatTtcPrice(amount: number): string {
    return new Intl.NumberFormat("fr-FR", {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
    }).format(Math.round(amount));
}

export function debounce(fn: (...args: any[]) => void, ms: number) {
    let timer: ReturnType<typeof setTimeout>;
    return (...args: any[]) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), ms);
    };
}

/**
 * Runs `fn` in a task scheduled after the next paint. Facet handlers defer
 * InstantSearch `refine()` through this so the tap's INP window closes on the
 * native checkbox toggle instead of spanning the whole state-change +
 * widget re-render work (~200ms on throttled mobile).
 */
export function runAfterFrame(fn: () => void): void {
    requestAnimationFrame(() => {
        window.setTimeout(fn, 0);
    });
}

export function escapeHtml(s: string): string {
    return s
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
}
